"use strict";

define('rs/checklist/checklist.view',['vertebrae'], function (Vertebrae) {
  var ChecklistView = Vertebrae.View.extend({
    templates: {
      'checklist.init': 'renderInitFragment'
    },
    events: {
      'click .checklist-closer': 'handleToggleClick',
      'change .multiple-checklist-selector': 'handleChecklistSelectionChange',
      'click .btn-checklist-save': 'handleChecklistSaveBtn'
    },
    getFormContainer: function getFormContainer() {
      return this.$('.checklist-form-container');
    },
    render: function render() {
      this.$el.addClass('e3-form-checklist e3-form-theme-default');
      this.$el.html(this.renderInitFragment(this.getDelegate().getTemplateProperties()));
    },
    open: function open() {
      this.isOpen = true;
      this.$el.addClass('open');
      this.$el.closest('.form-wrapper').addClass('open-checklist');
      setTimeout(function () {
        $('textarea').each(function () {
          if (this.scrollHeight > 0) {
            $(this).height(this.scrollHeight - 10);
            $(this).css('transition', 'all 0.1s ease-out');
          }
        });
      }, 500);
    },
    close: function close() {
      $('textarea').each(function () {
        if (this.offsetHeight > 0) {
          var prevWidth = $(this).width();
          var prevHeight = $(this).height();
          var area = prevWidth * prevHeight;
          var self = this;
          setTimeout(function () {
            $(self).height(area / self.offsetWidth + 5);
            $(self).css('transition', 'all 0.1s ease-out');
          }, 500);
        }
      });
      this.isOpen = false;
      this.$el.removeClass('open');
      this.$el.closest('.form-wrapper').removeClass('open-checklist');
    },
    handleChecklistSelectionChange: function handleChecklistSelectionChange(ev) {
      var selIndex = $(ev.currentTarget).val(),
        d = this.getDelegate(),
        cls = d.getChecklists();
      d.requestSelectChecklist(d.getChecklists()[selIndex]);
    },
    handleToggleClick: function handleToggleClick() {
      this.getDelegate().toggleChecklist();
    },
    handleChecklistSaveBtn: function handleChecklistSaveBtn() {
      this.getDelegate().saveCurrentFormAnswers();
    },
    refreshChecklistActions: function refreshChecklistActions() {
      var editable = this.getDelegate().getChecklistEditableState(),
        saveBtn = this.$('.btn-checklist-save');
      if (!editable) {
        saveBtn.addClass('disabled');
      } else {
        saveBtn.removeClass('disabled');
      }
    },
    resize: function resize() {
      var headerHeight = this.$('.checklist-header').height(),
        footerHeight = this.$('.checklist-footer').height(),
        parentHeight = this.$el.height();
      this.getFormContainer().css('max-height', parentHeight - headerHeight - footerHeight);
    }
  });
  return ChecklistView;
});

